import { apiClient } from '../client'

export type AdminChatSummary = {
  user_id: number
  job_id: number
  last_message: string
  last_message_at: string
  user_name: string | null
  user_avatar: string | null
  job_title: string | null
}

export type ChatMessage = {
  id: number
  user_id: number
  job_id: number
  sender_type: 'admin' | 'user'
  sender_id: number
  chat: string
  created_at: string
}

const unwrap = <T>(res: { data?: T }) => res.data

export const messagingRepository = {
  async getChats(): Promise<AdminChatSummary[]> {
    const res = await apiClient.get<{ data: AdminChatSummary[] }>('/api/admin/messaging/chats')
    return Array.isArray(unwrap(res)) ? unwrap(res)! : []
  },

  async getMessages(userId: number, jobId: number): Promise<ChatMessage[]> {
    const res = await apiClient.get<{ data: ChatMessage[] }>(
      `/api/admin/messaging/chats/${userId}/${jobId}/messages`,
    )
    return Array.isArray(unwrap(res)) ? unwrap(res)! : []
  },

  async sendMessage(userId: number, jobId: number, chat: string): Promise<ChatMessage> {
    const res = await apiClient.post<{ data: ChatMessage }>(
      `/api/admin/messaging/chats/${userId}/${jobId}/messages`,
      { chat },
    )
    return unwrap(res)!
  },
}
